import { render, staticRenderFns } from "./default-image.component.vue?vue&type=template&id=3bf43e6c&scoped=true"
import script from "./default-image.component.vue?vue&type=script&lang=ts"
export * from "./default-image.component.vue?vue&type=script&lang=ts"
import style0 from "./default-image.component.vue?vue&type=style&index=0&id=3bf43e6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf43e6c",
  null
  
)

export default component.exports